import { MathHelper } from "./MathHelper";

export class ArrayHelper {

    public static initArrayWithValues<T>(length: number, creator: (index: number) => T): T[] {
        const array: T[] = [];
        for (let i: number = 0; i < length; i++) {
            array.push(creator(i));
        }
        return array;
    }

    /**
     * Returns random value form array.
     * @param array T[]
     * @returns {T} 
     */
    public static getRandomValue<T>(array: T[]): T {
        return array[MathHelper.clamp(Math.round(Math.random() * array.length), 0, array.length - 1)];
    }

    /**
     * Sum of all numbers in array.
     * @param array number[]
     * @returns {number}
     */
    public static arraySum(array: number[]): number {
        return array.reduce((a: number, b: number) => { return a + b; }, 0);
    }

    /**
     * Fetch single value for the typeArr if it's either Array or Regular type.
     * @param typeArr  T | T[]
     * @param index number
     * @returns {T}
     */
    public static fetchArrTypeValue<T>(typeArr: T | T[], indx: number): T {
        return (Array.isArray(typeArr) ? (typeArr as T[])[indx] : typeArr as T);
    }

    public static typeConvert<T>(typeArr: T | T[]): T[] {
        return Array.isArray(typeArr) ? typeArr : [typeArr];
    }

    /**
     * Returns sum of condition hits.
     * @param array T[]
     * @param condition (element:T) => boolean
     * @returns {number} amount
    */
    public static countWithCondition<T>(array: T[], condition: (element: T) => boolean): number {
        return array.filter(item => condition(item)).length;
    }

    /**
    * Returns the first value of an array.
    * @param array T[]
    * @returns {T}
    */
    public static fetchFirstValue<T>(array: T[]): T { return array[0]; }

    /**
     * Returns the next value of an array, works only if it have unique values and an saved indicator index.
     * @param indicator T
     * @param arr:T[]
     * @returns {T}
     */
    public static fetchNextInList<T>(indicator: T, val: T[]): T {
        return val[(val.findIndex(v => v === indicator) + 1) % val.length];
    }

    /**
     * Returns the last value of an array.
     * @param array <T>
     * @returns {T}
     */
    public static fetchLastValue<T>(array: T[]): T { return array[array.length - 1]; }

    /**
     * Check if a value is out of reach of the supplied range.
     * Returns the "flipped" index of the range.
     * @param length the range start from index 0.
     * @param index
     * @returns {number}
     */
    public static reviseIndexInLoopRange(length: number, index: number): number {
        if (length <= 0) {
            debugger;
            throw new Error(`Error: ArrayHelper.getValueInLoopRange(): length must bigger than zero!`);
        }

        if (index > (length - 1)) {
            return index % length;
        }

        if (index < 0) {
            return length - (Math.abs(index) % length);
        }

        return index;
    }

    public static removeFirstMatchElement<T>(array: T[], element: T) {
        for (let i: number = 0; i < array.length; i++) {
            if (array[i] === element) {
                array.splice(i, 1);
                return;
            }
        }
    }

    public static indexOfArr<T>(array: T[], val: T[]): number {

        for (let i: number = 0; i < array.length; i++) {
            const checkVal: number = array.indexOf(array[i]);
            if (checkVal >= 0) return checkVal;
        }

        return -1;
    }

    public static removeFirstMatchElementWithCondition<T>(array: T[], condition: (element: T) => boolean) {
        for (let i: number = 0; i < array.length; i++) {
            if (condition(array[i])) {
                array.splice(i, 1);
                return;
            }
        }
    }

    /**
       * Swap Positions in an array
       * @param array 
       * @param a First position
       * @param b Second position
       * @returns {T[]}
       */
    public static swapPositions<T>(array: T[], a: number, b: number): T[] {
        return [array[a], array[b]] = [array[b], array[a]];
    }

    /**  
     * Uses an function trigger for each value in an dubbel array
     * Example usage -> "let count:number = 0; ArrayHelper.eachForEach(sizes, (val:number) => { count += val > 0 ? 1 : 0 })"
     * Example usage 2 -> "let count:number = 0; ArrayHelper.eachForEach(sizes, (val:number) => this.method(value))"
     * @param arr any:[][]
     * @param func (value:any) => void
     * @returns {void}
    */
    public static eachForEach(arr: any[][], func: (firstIndx: number, secondIndx: number, value: any) => void): void {
        for (let i: number = 0; i < arr.length; i++) {
            for (let k: number = 0; k < arr[i].length; k++) {
                func(i, k, arr[i][k])
            }
        }
    };

    public static eachReelRow(reelMap: any[][], func: (reel: number, row: number) => void): void {
        for (let reel: number = 0; reel < reelMap.length; reel++) {
            for (let row: number = 0; row < reelMap[reel].length; row++) {
                func(reel, row);
            }
        }
    };

    /**  
     * Find out how many indexes there is in a mega MultiArray
     * @param arr any
     * @returns {number} amount of indexes.
    */
    public static countAmountOfIndexes(arr: any, amm: number = 0): number {
        if (Array.isArray(arr)) {
            for (let i: number = 0; i < arr.length; i++) {
                if (Array.isArray(arr[i])) amm = this.countAmountOfIndexes(arr[i], amm);
                else return amm + arr.length;
            }
        }
        return amm;
    };

    /**
    * Shuffles the array.
    * @param array Any
    */
    public static shuffle<T>(array: T[]): T[] {
        for (let i = array.length; i; i--) {
            this.swapPositions(array, i - 1, Math.floor(Math.random() * i));
        }
        return array;
    }
}